// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { flaskTypeEnumEe622886 } from './FlaskTypeEnumEe622886';
import { organismId } from './Organism';
import { invItemId } from './InvItem';
import { operatorId } from './Operator';
import { z } from 'zod';
export const flaskId = (z.number());
export const flask = z.object({
    id: flaskId,
    working_stock_added_ml: z.string().nullable(),
    temperature: z.string().nullable(),
    rpm: z.number().nullable(),
    end_od: z.string().nullable(),
    start_time: z.date().nullable(),
    end_time: z.date().nullable(),
    flask_type: flaskTypeEnumEe622886.nullable(),
    organism_id: organismId.nullable(),
    total_main_components_g: z.string().nullable(),
    total_trace_g: z.string().nullable(),
    total_methanol_g: z.string().nullable(),
    target_weight_g: z.string().nullable(),
    methanol_invenventory_item_id: invItemId.nullable(),
    main_components_item_id: invItemId.nullable(),
    trace_item_id: invItemId.nullable(),
    dry_weight_g: z.string().nullable(),
    total_weight_g: z.string().nullable(),
    notes: z.string().nullable(),
    created_at: z.date(),
    created_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
    water_item_id: invItemId.nullable(),
    total_water_g: z.string().nullable(),
    base_item_id: invItemId.nullable(),
    total_base_g: z.string().nullable(),
});
export const flaskInitializer = z.object({
    id: flaskId.optional(),
    working_stock_added_ml: z.string().optional().nullable(),
    temperature: z.string().optional().nullable(),
    rpm: z.number().optional().nullable(),
    end_od: z.string().optional().nullable(),
    start_time: z.date().optional().nullable(),
    end_time: z.date().optional().nullable(),
    flask_type: flaskTypeEnumEe622886.optional().nullable(),
    organism_id: organismId.optional().nullable(),
    total_main_components_g: z.string().optional().nullable(),
    total_trace_g: z.string().optional().nullable(),
    total_methanol_g: z.string().optional().nullable(),
    target_weight_g: z.string().optional().nullable(),
    methanol_invenventory_item_id: invItemId.optional().nullable(),
    main_components_item_id: invItemId.optional().nullable(),
    trace_item_id: invItemId.optional().nullable(),
    dry_weight_g: z.string().optional().nullable(),
    total_weight_g: z.string().optional().nullable(),
    notes: z.string().optional().nullable(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    water_item_id: invItemId.optional().nullable(),
    total_water_g: z.string().optional().nullable(),
    base_item_id: invItemId.optional().nullable(),
    total_base_g: z.string().optional().nullable(),
});
export const flaskMutator = z.object({
    id: flaskId.optional(),
    working_stock_added_ml: z.string().optional().nullable(),
    temperature: z.string().optional().nullable(),
    rpm: z.number().optional().nullable(),
    end_od: z.string().optional().nullable(),
    start_time: z.date().optional().nullable(),
    end_time: z.date().optional().nullable(),
    flask_type: flaskTypeEnumEe622886.optional().nullable(),
    organism_id: organismId.optional().nullable(),
    total_main_components_g: z.string().optional().nullable(),
    total_trace_g: z.string().optional().nullable(),
    total_methanol_g: z.string().optional().nullable(),
    target_weight_g: z.string().optional().nullable(),
    methanol_invenventory_item_id: invItemId.optional().nullable(),
    main_components_item_id: invItemId.optional().nullable(),
    trace_item_id: invItemId.optional().nullable(),
    dry_weight_g: z.string().optional().nullable(),
    total_weight_g: z.string().optional().nullable(),
    notes: z.string().optional().nullable(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    water_item_id: invItemId.optional().nullable(),
    total_water_g: z.string().optional().nullable(),
    base_item_id: invItemId.optional().nullable(),
    total_base_g: z.string().optional().nullable(),
});
//# sourceMappingURL=Flask.js.map